import request from "root/js/request";

export const uploadIncomeCostCrossMP = async ({ cabinet_id, marketplace }, formData) => {
  const cost_file = formData.get("cost_file");
  if (cost_file) {
    formData.delete("cost_file");
    formData.append("cost_file", cost_file);
  }

  const response = await request({
    url: `/analytics/cross-mp/product_cost_income/upload_income_cost/`,
    method: "post",
    data: formData,
    params: {
      cabinet_id,
      marketplace,
    },
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Token ${localStorage.getItem("token")}`,
    },
  });
  return response;
};
